module.exports = __webpack_public_path__ + "media/application/images/svgs/alert-circle-f0a5dbcb4bfebb7202e6d5b70a1ac27d.svg";